const fixedNavObserver = require('../../components/fixedNavObserver/fixedNavObserver.js');
const featureDetection = require('../../components/featureDetection/featureDetection.js');
'use strict'

module.exports = (function () {
    /**
    * @ngdoc method
    * @name layoutJumpLinks
    * @description Initializes fixed jump links for the layout rows that activates on scroll
    **/

    // Needs only be initialized once per page
    // fix the tour jump nav strip on scroll
    var initialize = function() {
        var $body = $('body');
        
        var $submenuJumpLinks = $('.submenu-jump-links-section');
        if (!$submenuJumpLinks || $submenuJumpLinks.length === 0) {
            return;
        }

        var initialOffset = $submenuJumpLinks.offset().top;

        var $tourJumpLinks = $('.submenu-link');
        createJumpLinks($tourJumpLinks, initialOffset, $body);
        setActiveSection();

        fixSectionNav();
        setActiveSection();

        var scrollPos = 0;
        document.addEventListener('scroll', function () {
            var scrollDir = document.body.getBoundingClientRect().top > scrollPos ? 'up' : 'down';
            scrollPos = document.body.getBoundingClientRect().top;
            fixSectionNav(scrollDir);
            setActiveSection();
        }, featureDetection.isPassiveSupported() ? { passive: true } : false);
    }

    function createJumpLinks($jumpLinks, initialOffset, $pageWrapper) {
        var $variantContainer = $('.submenu-jump-link-bar');
        var variantContainerHeight = $variantContainer.height();
        console.info("Jump Links: ", $jumpLinks);
        $jumpLinks.on('click', function () {
            window.location.hash = this.hash;
            let $target = $(this.hash);
            $target = $target.length ? $target : $('[name=' + this.hash.slice(1) + ']');

            if ($target.length) {
                // Get fixed header height
                // must simulate future fixed header height before determining scroll position
                $pageWrapper.addClass('skip-animate');
                $pageWrapper.addClass('has-submenu-jump-links-section');

                var headerHeight = fixedNavObserver.getTotalFixedNavHeight();

                $(window).scrollTop($target.offset().top - headerHeight);

                $pageWrapper.removeClass('skip-animate');
                if ($(window).scrollTop() > initialOffset - variantContainerHeight) {
                    $pageWrapper.addClass('has-submenu-jump-links-section');
                } else {
                    $pageWrapper.removeClass('has-submenu-jump-links-section');
                }

                setActiveSection();
                return false;
            }
        });
    }

    function fixSectionNav(scrollDir) {
        var pageTopLayout = document.getElementsByClassName('layout-section')[0];
        var sectionJumpLinks = document.getElementById('submenu-jump-links');

        var headerNavWrapperData = fixedNavObserver.getHeightBySelector('.header-and-nav-wrapper');

        // Make sure to check if we are scrolling up to prevent jitter as we cross the boundary and padding is applied to the body
        if (scrollDir === 'down' && !document.body.classList.contains('has-submenu-jump-links-section') && sectionJumpLinks.getBoundingClientRect().top <= headerNavWrapperData.height) {
            document.body.classList.add('has-submenu-jump-links-section');
        } else if (scrollDir === 'up' && document.body.classList.contains('has-submenu-jump-links-section') && pageTopLayout.getBoundingClientRect().bottom > headerNavWrapperData.height) {
            document.body.classList.remove('has-submenu-jump-links-section');
        }
    }

    function setActiveSection() {
        const fixedHeaderHeight = fixedNavObserver.getTotalFixedNavHeight();
        const layoutRowSections = document.getElementsByClassName('layout-section');

        const desktopJumpLinks = document.querySelectorAll('.submenu-jump-links-section .submenu-link');

        const activeSection = _.find(layoutRowSections, function (vs) {
            const distance = vs.getBoundingClientRect().bottom - fixedHeaderHeight - 2; // add a couple of pixels of buffer to prevent off by 1 error
            return distance >= 0;
        });

        if (activeSection) {
            const sectionId = activeSection.id;
            for (var i = 0; i < desktopJumpLinks.length; i++) {
                const jumpLink = desktopJumpLinks[i];
                if (jumpLink.getAttribute('href') == '#' + sectionId) {
                    jumpLink.classList.add('active');
                }
                else {
                    jumpLink.classList.remove('active');
                }
            }
        }
    }

    // Return an object exposing the public items
    return {
        initialize: initialize
    };
}())